// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useInitiativeHeadingStyles = makeThemedStyles(
  "InitiativeHeading",
  (theme) => ({
    root: {
      color: "rgba(63, 69, 79, 1)",
      letterSpacing: "0.05625px",
      fontWeight: 600,
      margin: "0",
      fontFamily: "Ample, Helvetica",
      fontSize: "15px",
      lineHeight: "1.5em",
      marginBottom: "10px",
      marginTop: "10px",
    },
    subTitle: {
      display: "inline-flex",
      color: "rgba(76, 81, 87, 1)",
      margin: "0 1.142em",
      fontSize: "0.875em",
      fontWeight: 400,
    },
  })
);

const InitiativeHeading = (
  props: React.PropsWithChildren<{ subTitle?: string }>
) => {
  const styles = useInitiativeHeadingStyles();
  return (
    <div className={styles.root}>
      {props.children}{" "}
      {props.subTitle ? (
        <div className={styles.subTitle}>{props.subTitle}</div>
      ) : null}
    </div>
  );
};

export default InitiativeHeading;
